import React from 'react';
import "./App.css";
import "./styles/fonts.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Speaking from "./pages/Speaking";
import Contact from "./pages/Contact";
import Philanthropy from "./pages/Philanthropy";
import Technology from "./pages/Technology";
import Admin from "./pages/Admin";
import Login from "./pages/Login";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/philanthropy" element={<Philanthropy />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/work" element={<Work />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
